<div class="custom-background">
  <div class="container casestudies-body">
    <div class="row">
      <div class="col-md-5 custom-computer image-order">
        <img src="../../../../assets/industry/casestudies/custom-computerInsurance.png" class="img-fluid" alt="custom-compute"/>
      </div>

      <div class="col-md-7 py-5">
        <p class="text-white link-casestudy"><span (click)="nav('/')">Home</span> / <span (click)="nav('/kalpita-case-studies/case-study')">Case Studies</span></p>
        <h1 class="py-4 custom-head">
          Custom-built SharePoint interface to drive the right employee
          engagement in the organization
        </h1>
        <p class="py-3 custom-para">
          The client's objective was to create an effective learning platform,
          providing a centralized hub where all employees can access essential
          training information, and set up a business operating procedure for
          employees to follow.
        </p>
      </div>
    </div>
  </div>
</div>
<!-- The problem...................................................................... -->
<div class="challenge-background">
  <div class="container">
    <div class="row py-5">
      <h5 class="challenge-head">The problem</h5>
      <p class="py-3">
        Creating an in-house platform for employees to interact with on a
        regular basis so there is complete transparency in terms of business
        operating procedures, client onboarding, salesforce training, etc.
      </p>
    </div>
  </div>
</div>
<!-- The Solution................................................................................... -->
<div class="container">
  <div class="row">
    <div class="col-md-6 pt-5">
      <h5 class="challenge-head">The Solution</h5>
      <p class="py-4">
        We identified their intent and created a portal where the entire
         hub was designed to keep employees engaged with required information using SharePoint.
        Their entire business model was available as a reference to their employees with a
        click of a button
      <div class="row">
        <div class="col-4 text-center">
          <img
            src="../../../../assets/resources/casestudies/new-business.png"
            class="img-fluid" alt="business"
          />
          <p>New business</p>
        </div>
        <div class="col-4 text-center">
          <img
            src="../../../../assets/resources/casestudies/pre-placement.png"
            class="img-fluid" alt="preplcmnt"
          />
          <p>Pre-Placement</p>
        </div>
        <div class="col-4 text-center">
          <img src="../../../../assets/resources/casestudies/placement.png" class="img-fluid" alt="placement"/>
          <p>Placement</p>
        </div>
      </div>
      <div class="row py-3">
        <div class="col-6 text-center">
          <img
            src="../../../../assets/resources/casestudies/post-placement.png"
            class="img-fluid" alt="postplacement"
          />
          <p>Post Placement</p>
        </div>

        <div class="col-6 text-center">
          <img
            src="../../../../assets/resources/casestudies/post-plcmntwo.png"
            class="img-fluid" alt="postplcmntwo"
          />
          <p>Post Placement</p>
        </div>
      </div>
    </div>

    <div class="col-md-6 solution-background">
      <h5 class="text-white ps-3 py-5">
        The user interface we developed using SharePoint enabled our client to:
      </h5>
      <div class="solution-data ps-5 py-3">
        <ul>
          <li class="ico-img-sky">Personalized dashboard for each employee</li>
          <li class="ico-img-sky">Progress bars and tracking</li>
          <li class="ico-img-sky">Auto-generated email notifications and reminders</li>
          <li class="ico-img-sky">
            Store salesforce training material including videos and service
            model documents
          </li>
        </ul>
        <div class="row">
          <div class="col-5 text-center py-3">
            <div class="case-border">
              <img src="../../../../assets/resources/casestudies/rules.png" class="img-fluid" alt="rules"/>
              <p>Rules Of Engagment</p>
            </div>
          </div>

          <div class="col-5 text-center py-3">
            <div class="case-border">
              <img src="../../../../assets/resources/casestudies/create.png" class="img-fluid" alt="create"/>
              <p>How to create & manage</p>
            </div>
          </div>

          <div class="col-5 offset-1 text-center py-3">
            <div class="case-border">
              <img
                src="../../../../assets/resources/casestudies/account.png"
                class="img-fluid" alt="account"
              />
              <p>How to create contacts & Accounts</p>
            </div>
          </div>

          <div class="col-5 text-center py-3">
            <div class="case-border">
              <img
              src="../../../../assets/resources/casestudies/homescreen.png"
              class="img-fluid" alt="homescreen"
            />
            <p>Understanding your home screen</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<!-- Post placement main section.......................................................... -->
<div class="container py-5">
  <div class="row">
    <div class="col-md-8">
      <img src="../../../../assets/resources/casestudies/post-placebigimage.png" class="img-fluid" alt="postplace"/>
    </div>
    <div class="col-md-4">
      <h4 class="fw-bold post-heading">Content hubs for service model documents,
        assisting employees take the right call</h4>
    </div>
  </div>
</div>
